function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 141v-25.156c21.443-9.525 32.165-26.192 32.165-50.003H0V0h67.423v43.48C67.423 91.101 44.949 123.608 0 141zm112.577 0v-22.982c20.413-7.661 31.444-24.225 33.093-49.692h-33.093V0H180v43.79c0 30.23-4.536 51.866-13.608 64.91-8.866 12.837-26.804 23.604-53.815 32.3z",
  fill: "#F8DC00"
});
function SvgQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 141,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgQuote;